export const USER_DETAIL = 'USER_DETAIL'
export const USER_SETTING = 'USER_SETTING'

export default {
    USER_DETAIL,
    USER_SETTING,
}
